import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

function Roadmap() {
  const [roadmap, setRoadmap] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchRoadmap();
  }, []);

  const fetchRoadmap = async () => {
    try {
      const response = await axios.get(`${API_BASE}/roadmap`);
      setRoadmap(response.data);
    } catch (error) {
      console.error('Error fetching roadmap:', error);
    } finally {
      setLoading(false);
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'completed':
        return '#4caf50';
      case 'in_progress':
        return '#ff9800';
      case 'planned':
      default:
        return '#999';
    }
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case 'completed':
        return '✓ Completed';
      case 'in_progress':
        return '🔄 In Progress';
      case 'planned':
      default:
        return '📋 Planned';
    }
  };

  if (loading) {
    return (
      <div className="roadmap-page">
        <div className="empty-state">
          <p>Loading roadmap...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="roadmap-page">
      <div className="roadmap-header">
        <h1>Roadmap</h1>
        <p style={{ color: '#999', marginTop: '0.5rem' }}>Upcoming features and improvements</p>
      </div>

      {roadmap.length === 0 ? (
        <div className="empty-state">
          <p>No roadmap items yet. Check back soon for updates!</p>
        </div>
      ) : (
        <div className="roadmap-list">
          {roadmap.map((item) => (
            <div key={item.id} className="roadmap-item">
              <div className="roadmap-item-header">
                <h3>{item.title}</h3>
                <span 
                  className="roadmap-status"
                  style={{ color: getStatusColor(item.status) }}
                >
                  {getStatusLabel(item.status)}
                </span>
              </div>
              {item.description && (
                <p className="roadmap-description">{item.description}</p>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Roadmap;

